export default __webpack_public_path__ + "static/media/logo-white.2dfe915b.png";